import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";
import jwtDecode from "jwt-decode";
import {showWarning} from "../utils/notification.utils";
import {allowedModules} from "../utils/modules";
import {viewCustomerTabs, visibleTabs} from "../utils/utils";

const API_URL = process.env.BFF_URL;

class PermissionService {

  findAll(mid, params) {
    return http.get(API_URL + `/permissions`, {params: params, headers: authHeader()})
  }

  create(permission) {
    return http.post(API_URL + "/permissions", permission, {headers: authHeader()});
  }

  update(id, data) {
    return http.put(API_URL + `/permissions/${id}`, data, {headers: authHeader()});
  }

  findById(id) {
    return http.get(`/permissions/${id}`, {headers: authHeader()});
  }

  delete(id) {
    return http.delete(`/permissions/${id}`, {headers: authHeader()});
  }

  check(data) {
    return http.post(API_URL + "/app/permissions/check", data, {headers: authHeader()});
  }

  async checkPermissions(permissions) {
    let user = JSON.parse(localStorage.getItem('user'));
    let decoded = jwtDecode(user.token);
    let userId = decoded.sub;

    let data = {
      storeId: localStorage.getItem('mid'),
      userId: userId,
      permissions: permissions
    };

    try {
      const response = await http.post(API_URL + "/app/permissions/check", data, {headers: authHeader()});
      let success = response.data.success;

      if (success) {
        return {success: true, data: response.data.data};
      } else {
        return {success: false, error: 'Permission check failed'};
      }
    } catch (error) {
      console.error('Error: ', error);
      return {success: false, error: 'Failed to check permissions due to network error'};
    }
  }

  async getPageTabs(tabGroup, pagePermissions, id, locale) {
    const result = await this.checkPermissions(pagePermissions);
    if (!result.success) {
      await showWarning('Error during permissions check');
      return;
    }

    const permissions = result.data;
    const modules = allowedModules.filter(module => module.name === locale)[0].modules;
    const tabs = viewCustomerTabs(id).filter(tab => tab.tabGroup === tabGroup);

    return visibleTabs(tabs, permissions, modules, {
      locale: locale,
      component: 'this',
    });
  }
}

export default new PermissionService();



// WEBPACK FOOTER //
// ./src/service/permission.service.js